import { Component, effect, ElementRef, inject, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarItemComponent } from 'src/app/shared/components/master-detail-layout/sidebar-item/sidebar-item.component';
import { SidebarSectionComponent } from 'src/app/shared/components/master-detail-layout/sidebar-section/sidebar-section.component';
import { PrintersModuleService } from '../../services/printers-module.service';
import { CommonModule } from '@angular/common';
import { Printers } from 'tilby-models';
import { mobileCheck } from 'src/utilities';
import { GeneralSettingsFields, SelectionType } from '../../models/settings-printers.model';
import { SidebarBaseComponent } from 'src/app/shared/components/master-detail-layout/sidebar-base/sidebar-base.component';
import { $state } from 'app/ajs-upgraded-providers';
import { PrinterNavigationStateService } from '../../services/printer-navigation-state.service';
import { GeneralSettingsFormService } from '../../services/general-settings-form.service';
import { PrinterFormService } from '../../services/printer-form.service';
import { NewPrinterFormService } from '../../services/new-printer-form.service';

@Component({
  selector: 'app-printers-list',
  standalone: true,
  imports: [
    CommonModule,
    SidebarItemComponent,
    SidebarSectionComponent,
    SidebarBaseComponent,
    TranslateModule, MatButtonModule,
    MatIconModule
  ],
  templateUrl: './printers-list.component.html',
  styleUrl: './printers-list.component.scss'
})
export class PrintersListComponent implements OnInit, OnDestroy {

  protected readonly printerModuleService = inject(PrintersModuleService);
  private readonly printerNavigationStateService = inject(PrinterNavigationStateService);
  private readonly generalSettinfsFormService = inject(GeneralSettingsFormService);
  private readonly newPrinterFormService = inject(NewPrinterFormService);
  private readonly printerFormService = inject(PrinterFormService);
  private readonly state = inject($state);

  @ViewChild('sidebarContent') sidebarContent!: ElementRef;
  @ViewChildren('groupedItemContent', { read: ElementRef }) groupedItemContent!: QueryList<ElementRef>;


  private currentData: any;

  protected groupedPrinters: Map<string, Printers[]> = new Map();

  protected printersList: Printers[] = [];
  protected selectedPrinter: Printers | null = null;

  protected isMobile = mobileCheck();
  protected showDetailMobile = false;

  constructor() {
    effect(() => {
      if(this.printerModuleService.printersMapLoaded()) {
        this.groupedPrinters = this.printerModuleService.printersMap;
      }
    })

    effect(() => {
      // [
      //   this.printerModuleService.selection()
      // ]

      const currentSelection = this.printerModuleService.selection();

      if(currentSelection?.type === 'GENERAL') {
        if(this.printerNavigationStateService.isInternalItemChange) {
          this.printerNavigationStateService.isInternalItemChange = false;
          this.generalSettinfsFormService.createForm(currentSelection.generalSettings as GeneralSettingsFields);
        }
        this.printerNavigationStateService.initialData = structuredClone(this.generalSettinfsFormService.form?.getRawValue());
        this.currentData = this.generalSettinfsFormService.form;
      } else if(currentSelection?.type === 'PRINTER') {
        if(currentSelection && this.printerNavigationStateService.isInternalItemChange) {
          this.printerNavigationStateService.isInternalItemChange = false;
          this.printerFormService.createForm(currentSelection.printer as Printers);
        }
        this.printerNavigationStateService.initialData = structuredClone(this.printerFormService.form?.getRawValue());
        this.currentData = this.printerFormService.form;
      } else if(currentSelection?.type === 'NEW') {
        if(currentSelection && this.printerNavigationStateService.isInternalItemChange) {
          this.printerNavigationStateService.isInternalItemChange = false;
          this.newPrinterFormService.createForm();
        }
        this.printerNavigationStateService.initialData = structuredClone(this.newPrinterFormService.form?.getRawValue());
        this.currentData = this.newPrinterFormService.form;
      }

      if(this.isMobile && currentSelection) this.printerModuleService.updateShowDetailMobile(true);

      if(this.isMobile && !currentSelection) {
        this.currentData = structuredClone(this.printerNavigationStateService.initialData);
      }

    }, {allowSignalWrites: true})
  }

  ngOnInit() {
    this.printerNavigationStateService.register(() => this.printerNavigationStateService.checkChanges(this.currentData));
  }

  isGroupSelected(groupValue: any[]): boolean {
    return groupValue.some(printer => this.isSelected('PRINTER', printer.id));
  }

  get groupedPrintersArray() {
    return Array.from(this.groupedPrinters.entries()).map(([key, value]) => ({
      key,
      value
    }));
  }

  async onSelectGeneral() {
    if(this.state.current.name !== "app.new.settings.printers.general") {
      this.state.go('app.new.settings.printers.general');

      if (this.isMobile) {
        this.showDetailMobile = true;
      }
    }
  }

  isSelected(type: SelectionType, id?: number): boolean {
    const current = this.printerModuleService.selection();
    if (type === 'GENERAL') return current?.type === 'GENERAL';
    return current?.type === 'PRINTER' && current.printer?.id === id;
  }

  async selectPrinter(printer: Printers, groupIndex: number, itemIndex: number) {
 
    if(printer.id && this.printerModuleService.selection()?.printer?.id !== printer.id) {
      this.state.go('app.new.settings.printers.detail', { id: printer.id });

      if (this.isMobile) {
        this.showDetailMobile = true;
      }
    }
  }

  createNewPrinter() {
    this.state.go('app.new.settings.printers.new');
    this.printerModuleService.scrollToStart();
  }

  ngOnDestroy() {
    this.printerNavigationStateService.unregister();
  }
}
